import { render } from "./otherWeb.vue?vue&type=template&id=cb98bf06"
import script from "./otherWeb.vue?vue&type=script&lang=js"
export * from "./otherWeb.vue?vue&type=script&lang=js"

import "./otherWeb.vue?vue&type=style&index=0&id=cb98bf06&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__